exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sin-resultados > .alert[data-v-1fff9e88] {\n  color: #8a6d3b;\n  border: none;\n  position: relative;\n  background-color: #ffdd87;\n  padding: 20px 15px 15px 90px;\n  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);\n}\n.sin-resultados > .alert > i[data-v-1fff9e88] {\n  left: 10px;\n  bottom: -8px;\n  position: absolute;\n  font-size: 75px;\n}\n.sin-resultados > .alert > p[data-v-1fff9e88] {\n  font-size: 25px;\n  font-weight: 100;\n  margin-bottom: 5px;\n}\n.sin-resultados > .alert > .btn[data-v-1fff9e88] {\n  font-style: normal;\n  border-color: #f6bb42;\n  background-color: #f6bb42;\n}", ""]);

// exports
